import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=2722c7d7"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports